import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import BankAccount from "./BankAccount";
import GridConfig from "./GridConfig";
import { Header } from './Header';
import { Footer } from './Footer';

export default class BankAccounts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'bankaccount',
            data: null,
            loading: true,
            configName: 'bankaccounts_grid',
            moduleName: 'حسابهای بانکی',
            systemModuleId: 8,
            moduleAccessStatus: 1,
            menuId: 20
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    showTransactions(id) {
        this.showComponents({ component: <BankAccount Caller={this} Id={id} /> });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <BankAccount Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <BankAccount Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "code", caption: "کد", show: true },
                { field: "name", caption: "عنوان حساب", show: true },
                { field: "number", caption: "شماره حساب", show: true },
                { field: "branch", caption: "شعبه", show: true },
                { field: "remain", caption: "گردش حساب", show: true },
                { field: "tashkhis", caption: "تشخیص", show: true },
                { field: "sheba", caption: "شماره شبا", show: false }, ,
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }        
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.name}</a> } });
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'branch' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            if (f.field == 'tashkhis' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'sheba' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });   
        });

        t.push({
            field: "id", headerName: "عملیات", cellRenderer: (props) => {
                return props.data.code > 0 && <NavLink className="hand text-warning mx-1" to={"/report/transaction/3/" + props.data.code + "/"} title="مشاهده تراکنش های حساب">
                    <em className="icon ni ni-file-docs"></em>
                </NavLink>,
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
            }
        });
        return t;
    }

    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
        
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false, config: false, otherFilters: null })}
                            {this.renderAgGrid({
                                columnDefs: this.getColumns()
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}